import { IWedding_Website_Section } from '@bridebook/models/source/models/Weddings.types';

export const shouldShowWebsiteSection = (section?: IWedding_Website_Section) =>
  section?.visible ?? false;
